import React from 'react'
import './interest.css'
export default function interest() {
  return (
    <div className='interests'>
      <ul>
        <li>
          <div>
            <h5>GYM</h5>
            <p>My passion for maintaining a healthy lifestyle has led me to develop a strong interest in working out at the gym.</p>
          </div>
        </li>
        <li>
          <div>
            <h5>Poetry</h5>
            <p>Poetry offers a unique and powerful medium for exploring complex ideas and emotions, and I find reading it to be a deeply rewarding experience.</p>
          </div>
        </li>
        <li>
          <div>
            <h5>Books Reading</h5>
            <p>Enthusiastic reader with a strong interest in books and a dedication to constant learning through reading.</p>
          </div>
        </li>
      </ul>

    </div>
  )
}
